import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    modal: {
        videoId: undefined,
        mode: ""
    }
};

const videoSlice = createSlice({
    name: "video",
    initialState,
    reducers: {
        addVideoModal: (state, action) => {
            if (action.payload.type === "open") {
                state.modal.videoId = undefined
                state.modal.mode = "add"
            } else {
                state.modal.videoId = undefined
                state.modal.mode = ""
            }

        },
        updateVideoModal: (state, action) => {
            if (action.payload.type === "open") {
                state.modal.videoId = action.payload.videoId
                state.modal.mode = "edit"
            } else {
                state.modal.videoId = undefined
                state.modal.mode = ""
            }

        }
    },
});

export const { addVideoModal, updateVideoModal } = videoSlice.actions;
export default videoSlice.reducer;
